<template>
<div id="ListEquipamento" class=" container small">
  <div id="modal-template" v-if="showModal" @close="showModal = false">
    <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">
              <div class="modal-header">
                <slot name="header">
                  Detalhes da Atribuição do Equipamento
                </slot>
              </div>
              <div class="modal-body">
                <slot name="body">
                  <EquipamentoPessoa :equipamentoId="elementId" @list-closeModal="closeModal()"></EquipamentoPessoa>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
  </div>
  <div id="modal-confirm" v-if="showModalConfirm" @close="showModalConfirm = false">
    <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">
              <div class="modal-body">
                <slot name="body">
                  <Confirm :texto="texto" :elementId="elementId" @confirm-cancel="closeModalConfirm()" @confirm-ok="onDelete()"></Confirm>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
  </div>
<div class="card">    
  <div class="card-header ">
    Lista de Equipamentos <router-link class="btn btn-success s" :to="{ name: 'AddEquipamento' }" >Adicionar</router-link>
    <form class="form-inline float-right" v-on:submit.prevent>
      <i class="fas fa-search busca" aria-hidden="true"></i> 
      <input class="form-control float-right" type="text" aria-label="Pesquisar" v-model="tBusca" v-on:keydown="eBusca">
    </form>
    <div class="accordion" id="accordionExample">
      <div class="card">
        <div class="card-header ch-filtros" id="headingOne">
          <h5 class="mb-0">
            <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseFiltro" aria-expanded="true" aria-controls="collapseFiltro">
              Filtros
            </button>
          </h5>
        </div>
        <div class="row collapse" id="collapseFiltro">
          <div class="form-group col-md-4">
            <label v-for="t in tipos" v-bind:key="t.id"  class="container checkbox-inline">
              <input v-on:change="selecionaTipo(t.id)"  type="checkbox"> {{t.descricao}}
              <span class="checkmark"></span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body">    
    <div class="table-responsive">
      <table class="table table-sm">
        <thead>
          <tr>
            <th scope="col">
            </th>
            <th>
            </th>
            <th>
            </th>
            <th>
            </th>
            <th>
              Equipamento
            </th>
            <th>
              Data Entrada
            </th>
            <th>
              Data Nota
            </th>
            <th>
              Marca\Modelo
            </th>
            <th>
              IMEI
            </th>
            <th>
              N/S
            </th>
            <th>
              Núm. Nota
            </th>
            <th>
              Fornecedor
            </th>
            <th>
              Valor (R$)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="obj in equipamentos" v-bind:key="obj.id">
            <td>
              <a href="#" class="icon">
                <i v-on:click="setShowModalConfirm('Deseja realmente excluir?', obj.id)" class="fa fa-trash"></i>
              </a>
            </td>
            <td>
              <router-link :to="{ name: 'AddEquipamento', params: { equipamento_id : obj.id , acao : 'editar'  } }" class="icon">
                <i class="fa fa-edit"></i>
              </router-link>
            </td>
            <td>
              <router-link  :to="{ name: 'AddEquipamento', params: { equipamento_id : obj.id , acao : 'copiar' } }" class="icon">
                <i class="fa fa-copy"></i>
              </router-link>
            </td>
            <td>
              <a href="#" v-if="obj.pessoa_id" class="icon">
                <i v-on:click="onLink(obj.id)" class="fa fa-link"></i>
              </a>
              <a href="#" v-if="!obj.pessoa_id" class="icon">
                <i class="fa fa-unlink"></i>
              </a>
              <!--  <i v-on:click="updateEquipamento" class="fa fa-edit"></i> --->
            </td>
            <td>
              {{obj.tipo_equipamento.descricao}}
            </td>
            <td>
              {{obj.data_entrada | formatDateDb }}
            </td>
            <td>
              {{obj.data_nota | formatDateDb }}
            </td>
            <td>
              {{obj.marca_modelo}}
            </td>
            <td>
              {{obj.imei1}} / {{obj.imei2}}
            </td>
            <td>
              {{obj.num_serie}}
            </td>
            <td>
              {{obj.num_nota}}
            </td>
            <td>
              {{obj.fornecedor}}
            </td>
            <td>
              {{obj.valor}}
            </td>            
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>

</template>
<script>

import AddEquipamento from './AddEquipamento'//
import EquipamentoPessoa from './EquipamentoPessoa'//
import Confirm from '../Confirm'

const fb = require('../../config/db.js')

export default {
  name: 'ListEquipamento',
  components: {
   AddEquipamento,
   Confirm,
   EquipamentoPessoa
  },
  data() {
    return {
      equipamentos: [],
      showModal: false,
      showModalConfirm: false,
      texto: '',
      elementId: '',
      tBusca: '',
      tipos: [],
      tiposSelecionados: [],
      newEquipamento: {
        'tipo_equipamento' : { 'idtipo_equipamento' : "", 'descricao' : '' }, 
        'marca_modelo' : "", 
        'imei' : "", 
        'num_serie' : "",
        'num_nota' : "", 
        'data_nota' : "", 
        'valor' : "", 
        'fornecedor' : "", 
        'data_entrada' : '',  
      },
    }
  },
  created() {
    this.tiposSelecionados = [];
    this.getTipoEquipamentos();
    this.getEquipamentos('');
  },
  methods: {
    eBusca: function(){
      if (this.tBusca.length >= 3)
        this.getEquipamentos(this.tBusca)
      else
        this.getEquipamentos('');
    },
    selecionaTipo(id){
      const i = this.tiposSelecionados.indexOf(id);
      if (i >= 0)
        this.tiposSelecionados.splice(i, 1);
      else
        this.tiposSelecionados.push(id);

      if (this.tBusca.length >= 3)
        this.getEquipamentos(this.tBusca)
      else
        this.getEquipamentos('');
    },
    getTipoEquipamentos(){
      fb.TipoEquipamento.get().then(querySnapshot =>{
        const objects = []
        let tp = []
        querySnapshot.forEach((doc)=>{
          tp =  doc.data();
          tp.id = doc.id;
          objects.push(tp);
        });
        this.tipos = objects;
      });
    },
    setShowModalConfirm(texto, id){
      this.texto = texto;
      this.elementId = id;
      this.showModalConfirm = true;
    },
    closeModalConfirm(){
      this.showModalConfirm = false;
      this.getEquipamentos('');
    },
    setShowModal(){
      this.showModal = true;
    },
    closeModal(){
      this.showModal = false;
      this.getEquipamentos();
    },
    updateEquipamento(){
      fb.Equipamento.where("del", "==", "n").orderBy('tipo_equipamento.descricao').orderBy('marca_modelo').get().then(querySnapshot =>{
        let e = {};
        let i = 1;
        let codigo;
        querySnapshot.forEach((doc)=>{
          e =  doc.data();
          e.id = doc.id;
          if (e.tipo_equipamento.descricao == 'Impressora Mesa')
            codigo = 'IM'+("0000" + i).slice(-4);
          else if (e.tipo_equipamento.descricao == 'Desktop')
            codigo = 'DE'+("0000" + i).slice(-4);
          else if (e.tipo_equipamento.descricao == 'Impressora Portátil')
            codigo = 'IP'+("0000" + i).slice(-4);
          else if (e.tipo_equipamento.descricao == 'Celular')
            codigo = 'CE'+("0000" + i).slice(-4);
          else if (e.tipo_equipamento.descricao == 'Diversos')
            codigo = 'DI'+("0000" + i).slice(-4);
          else if (e.tipo_equipamento.descricao == 'Notebook')
            codigo = 'NT'+("0000" + i).slice(-4);
          i++;
          fb.Equipamento.doc(e.id).update({
            'codigo': codigo
          });
        });
      });

      alert('Atualizados com sucesso')


    },
    getEquipamentos(busca){

      if (String(busca).trim() == ''){
        fb.Equipamento.where("del", "==", "n").orderBy('tipo_equipamento.descricao').orderBy('marca_modelo').get().then(querySnapshot =>{
          const objects = []
          querySnapshot.forEach((doc)=>{
            this.newEquipamento =  doc.data();
            this.newEquipamento.id = doc.id;
            if (this.tiposSelecionados.length <= 0) {
              objects.push(this.newEquipamento);
            } else { 
              if(this.tiposSelecionados.indexOf(this.newEquipamento.tipo_equipamento.idtipo_equipamento) >= 0) { 
                objects.push(this.newEquipamento);
              }
            }          
          });
          this.equipamentos = objects;
        });
      }else{
        fb.Equipamento.where("del", "==", "n").orderBy('tipo_equipamento.descricao').orderBy('marca_modelo').get().then(querySnapshot =>{
          const objects = []
          querySnapshot.forEach((doc)=>{
            this.newEquipamento =  doc.data();
            this.newEquipamento.id = doc.id;
            if ((String(this.newEquipamento.tipo_equipamento.descricao).toUpperCase().search(this.tBusca.toUpperCase()) >= 0)
            || (String(this.newEquipamento.marca_modelo).toUpperCase().search(this.tBusca.toUpperCase()) >= 0)
            || (String(this.newEquipamento.imei).toUpperCase().search(this.tBusca.toUpperCase()) >= 0)
            || (String(this.newEquipamento.num_serie).toUpperCase().search(this.tBusca.toUpperCase()) >= 0)
            || (String(this.newEquipamento.num_nota).toUpperCase().search(this.tBusca.toUpperCase()) >= 0)
            || (String(this.newEquipamento.fornecedor).toUpperCase().search(this.tBusca.toUpperCase()) >= 0)
            || (String(this.newEquipamento.valor).toUpperCase().search(this.tBusca.toUpperCase()) >= 0)
            ){
              if (this.tiposSelecionados.length <= 0) {
                objects.push(this.newEquipamento);
              } else { 
                if(this.tiposSelecionados.indexOf(this.newEquipamento.tipo_equipamento.idtipo_equipamento) >= 0) { 
                  objects.push(this.newEquipamento);
                }
              }
            }
            

          });
          this.equipamentos = objects;
        });
      }
    },
    onLink(id){
      this.elementId = id;
      this.setShowModal();
    },
    onEdit(obj){
      this.equipamento = obj;
    },
    onCopy(obj){
      this.equipamento = obj;
      this.equipamento.id = null;
    },
    onDelete(){
      fb.Equipamento.doc(this.elementId).update({
        'del': 's',
        'usuario_del': fb.auth.currentUser.email,
        'data_del': new Date()
      });
      this.elementId = '';
      this.showModalConfirm = false;
      this.getEquipamentos('');
    }

  }
}
</script>
<style scoped>

  .busca{
    margin-right: 10px;
  }

  .card{
    margin: 10px;
  }
  .row{
    margin: 10px;
  }
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 90%;
    max-height: calc(100% - 120px);
    overflow-y: scroll;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-default-button {
    float: right;
  } 

  /*
  * The following styles are auto-applied to elements with
  * transition="modal" when their visibility is toggled
  * by Vue.js.
  *
  * You can easily play with the modal transition by editing
  * these styles.
  */

  .ch-filtros {
    padding: 0px;
  }


  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }


  .card-header .form-group {
    margin-top: 20px;
  }

  .checkbox-inline {
    display: block;
    position: relative;
    padding-left: 20px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  /* Hide the browser's default checkbox */
  .checkbox-inline input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  /* Create a custom checkbox */
  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 15px;
    width: 15px;
    background-color: #eee;
  }

  /* On mouse-over, add a grey background color */
  .checkbox-inline:hover input ~ .checkmark {
    background-color: #ccc;
  }

  /* When the checkbox is checked, add a blue background */
  .checkbox-inline input:checked ~ .checkmark {
    background-color: #2196F3;
  }

  /* Create the checkmark/indicator (hidden when not checked) */
  .checkmark:after {
    content: "";
    position: absolute;
    display: none;
  }

  /* Show the checkmark when checked */
  .checkbox-inline input:checked ~ .checkmark:after {
    display: block;
  }

  /* Style the checkmark/indicator */
  .checkbox-inline .checkmark:after {
    left: 5px;
    top: 2px;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    transform: rotate(45deg);
  }
  
</style>